// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__223Wp","col":"styles_col__1z-Hk"};